import { useNavigate } from "react-router-dom";
import { ROUTE_URLS } from "../../../constants/consts";
import { clearLocalStorage } from "../../../api/sessionManagement";
import { clearUserLanguageCache } from "../../../hooks/useUserLanguage.hook";
import { useTranslation } from "react-i18next";
import { UIButton, UIModal } from "ui";

interface SuccessModalProps {
  showSuccessModal: boolean;
  closeModal: VoidFunction;
}

export const SuccessModal = ({ showSuccessModal, closeModal }: SuccessModalProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    closeModal();
    clearLocalStorage();
    clearUserLanguageCache();
    const browserLang = navigator.language || 'en-GB';
    i18n.changeLanguage(browserLang);
    navigate(ROUTE_URLS.SIGN_IN);
    window.dispatchEvent(new Event("storage"));
    window.location.reload();
  };

  return (
    <UIModal open={showSuccessModal} onClose={handleClose} width={420} centered>
      <div style={{ fontWeight: "bold", textAlign: "center", paddingTop: 16, fontSize: 22 }}>
        {t("navbar.success_modal.title")}
      </div>
      <div style={{ textAlign: "center", width: "100%", padding: "16px 0" }}>
        {t("navbar.success_modal.description")}
      </div>
      <div style={{ display: "flex", justifyContent: "center", paddingBottom: 8 }}>
        <UIButton variant="contained" onClick={handleClose}>
          {t("navbar.success_modal.button")}
        </UIButton>
      </div>
    </UIModal>
  );
};
